import React from "react";
import leftarrow from "../../../../assets/img/admin/arrow-left-1.svg";
import user from "../../../../assets/img/admin/user.svg";
import trash from "../../../../assets/img/admin/trash.svg";
import img from "../../../../assets/img/Home/Rectangle 23.png";
import profile from "../../../../assets/img/Home/profile.png";
import Button from "../../../shared/Button";
const AdminJudgeCard = ({}) => {
  return (
    <div className=" rounded-[16px] bg-[#fff] p-[36px]" style={{boxShadow: "30px 30px 130px 0px rgba(0, 0, 0, 0.03)"}}>
      <div className="flex justify-between items-center">
        <div className="flex  gap-[19px]">
          <img src={img} className="w-[200px] h-[120px] rounded-[16px]" />
          <div className=" flex-col  justify-between flex py-[10px]">
            <div className="flex items-center gap-[4px] ">
              <img src={user} />
              <p className="text-[16px] text-[#00A6A6] font-[400]">
                <span className="font-[700]">مهمان</span> : سجاد لطیفی
              </p>
            </div>
            <h4 className="text-[20px] text-[#292D32] font-[700]  w-[70%]">اجاره مجتمع اقامتگاهی ایوان بوتیک - واحد یک خوابه کیش</h4>
          </div>
          
        </div>
        <div className="flex items-center gap-[24px]">
            <p className="text-[28px] text-[#00A6A6] font-[700] list-outside"> <span className="mx-[20px] font-bold text-[64px]">.</span>در انتظار تایید</p>
            <img src={trash} />
          </div>
      </div>
      <hr  className="my-[36px] border-dashed"/>
      <div className="flex justify-between items-center">
        <div className="flex gap-[15px] items-stretch">
          <img src={profile} />
          <div>
            <p className="text-[16px] text-[#51555A] font-[500]">میزبان اقامتگاه</p>
            <p className="text-[20px] text-[#00A6A6] font-[700]">محمد خضر پور</p>
          </div>
        </div>

        <div>
          <p className="text-[14px] text-[#5B5F64] font-[500]">تاریخ ثبت شکایت</p>
          <div className="text-[16px] text-[#12171C] font-[500] rounded-[8px] bg-[#F0F0F0] py-[4px] px-[16px]">1402 / 06 / 01</div>
        </div>
        <Button varient="primary">تایید شکایت</Button>
      </div>
    </div>
  );
};

const AdminJudgeDetail = () => {
  return (
    <div>
      <div className="flex justify-between items-center ">
        <h4 className="text-[36px] text-[#12171C] font-[700] mb-[36px] ">
          کارمزد های وبسایت
        </h4>
        <button className="flex items-center gap-[8px]">
        <p className="text-[20px] text-[#00A6A6] font-[500]">بازگشت</p>
          <img src={leftarrow} />
        
        </button>
      </div>
      <AdminJudgeCard />
      <p className="text-[18px] text-[#797D82] bg-[#F0F0F0] rounded-[16px] font-[500] p-[20px] mt-[48px]">
        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده
        از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و
        سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای
        متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه
        درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با
        نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان
        خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید
        داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان
        رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات
        پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.
      </p>
    </div>
  );
};

export default AdminJudgeDetail;
